import { RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/demo',
    name: 'demo',
    component: () => import('../views/WeeksStudy/Demo.vue'),
    meta: {
      title: '好未来图书'
    }
  },
  {
    path: '/WeeksStudy/contents',
    name: 'WeeksStudyContents',
    component: () => import('../views/WeeksStudy/Contents.vue'),
    meta: {
      title: '好未来图书'
    }
  },
  {
    path: '/WeeksStudy/exercises',
    name: 'WeeksStudyExercises',
    component: () => import('../views/WeeksStudy/Exercises.vue'),
    meta: {
      title: '',
      keepAlive: false,
      showActionBar: false
    }
  }
]

export default routes
